document.addEventListener('DOMContentLoaded',()=>{
 const form=document.querySelector('#nv-product-form');
 if(!form)return;
 const json=document.querySelector('#NvVariants');
 if(!json)return;
 const variants=JSON.parse(json.textContent);
 const hidden=form.querySelector('[data-nv-variant-id]');
 const add=form.querySelector('[data-nv-add]');
 const mobile=document.querySelector('[data-nv-mobile-add]');
 const fmt=c=>(c/100).toLocaleString('sv-SE',{style:'currency',currency:'SEK'});
 function update(){
   const selected=[...form.querySelectorAll('[data-nv-option]')].map(g=>g.querySelector('input:checked')?.value);
   const v=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
   if(!v)return;
   hidden.value=v.id;
   document.querySelectorAll('[data-nv-price],[data-nv-price-mobile]').forEach(el=>el.textContent=fmt(v.price));
   add.disabled=!v.available;
   add.textContent=v.available?'LÄGG I VARUKORG':'SLUTSÅLD';
 }
 form.querySelectorAll('[data-nv-option] input').forEach(el=>el.addEventListener('change',update));
 if(mobile) mobile.addEventListener('click',()=>add.click());
});

document.addEventListener('DOMContentLoaded',()=>{
  const gallery=document.querySelector('[data-nv-gallery]');
  if(!gallery)return;
  const items=[...gallery.children].slice(0,5);
  const count=document.querySelector('[data-nv-gallery-count]');
  const prev=document.querySelector('[data-nv-prev]');
  const next=document.querySelector('[data-nv-next]');

  if(count) count.textContent=`1 / ${items.length}`;

  function currentIndex(){
    if(!items.length)return 0;
    const center=gallery.scrollLeft + gallery.clientWidth/2;
    let best=0, dist=Infinity;
    items.forEach((el,i)=>{
      const c=el.offsetLeft + el.offsetWidth/2;
      const d=Math.abs(c-center);
      if(d<dist){dist=d;best=i;}
    });
    return best;
  }

  function update(){
    if(count) count.textContent=`${currentIndex()+1} / ${items.length}`;
  }

  function go(delta){
    if(!items.length)return;
    const i=Math.max(0,Math.min(items.length-1,currentIndex()+delta));
    gallery.scrollTo({left:items[i].offsetLeft,behavior:'smooth'});
    setTimeout(update,350);
  }

  gallery.addEventListener('scroll',()=>requestAnimationFrame(update));
  if(prev)prev.addEventListener('click',()=>go(-1));
  if(next)next.addEventListener('click',()=>go(1));
});

document.addEventListener('DOMContentLoaded',()=>{
  const gallery=document.querySelector('[data-nv-gallery]');
  const form=document.querySelector('#nv-product-form');
  if(!gallery || !form) return;
  const items=[...gallery.querySelectorAll('.nv-product-media')];
  const count=document.querySelector('[data-nv-gallery-count]');

  function jumpToColor(color){
    const index=items.findIndex(el=>el.dataset.color===color);
    if(index<0)return;
    gallery.scrollTo({left:items[index].offsetLeft,behavior:'smooth'});
    if(count) count.textContent=`${index+1} / ${items.length}`;
  }

  const colorGroup=[...form.querySelectorAll('[data-nv-option]')].find(group=>{
    const legend=group.querySelector('legend');
    return legend && /color|färg/i.test(legend.textContent);
  });

  if(colorGroup){
    colorGroup.querySelectorAll('input').forEach(input=>{
      input.addEventListener('change',()=>jumpToColor(input.value));
    });
  }
});
